module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-gb-dca46d4f76ec7aecb21b38faf1ca65ad.svg";